(function($)
{
    $.extend(true, orion, {
        api: {
            availabilityWatchlist: {}
        }
    });

    var
        api = orion.api.availabilityWatchlist,
        uri = '/api-availability-watchlist/';

    function create(productNumber)
    {
        var promise = $.ajax(uri, {
            data: { productNumber: productNumber },
            'method': 'POST'
        });

        return promise;
    }

    function read(productNumber)
    {
        var promise = $.ajax(uri, {
            data: { productNumber: productNumber },
            'method': 'GET'
        });

        return promise;
    }

    api.create = create;
    api.read = read;
})(jQuery);
